
import BaseButton from '@/components/baseComponents/BaseButton.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { BaseButton },
})
export default class LandingSteps extends Vue {}
